"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOM_METRIC_REGEX = void 0;
exports.CUSTOM_METRIC_REGEX = /{[^}]*}/g;
